import {Customer} from "../../../model/customer/customer";
import {Injectable} from "@angular/core";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {CustomerComponent} from "../../../crystal-clear/customer/customer/customer.component";

@Injectable({
  providedIn: 'root'
})
export class CustomerCustomerTableConfigService  {

  public loadConfig(component: CustomerComponent): TableColumnConfig[]{

    const tableConfig:TableColumnConfig[] = [];
    if (!component.getIsReadOnly()) {
      tableConfig.push(
        {
          width: 30,
          type: 'BUTTON',
          notFilterable: true,
          notSortable: true,
          notResizable: true,
          class: value => 'centered',
          icon: value => value.enabled ? 'fas fa-toggle-on record-enabled' : 'fas fa-toggle-off record-disabled',
          command: (record: Customer) => {
            this.enableRecord(component, record);
          },
          mapId: value => '',
          hidden: component.getIsReadOnly()
        });
    }
    tableConfig.push(
      {
        field: 'owner',
        width: 100
      },
      {
        field: 'code',
        width: 130
      },
      {
        field: 'name',
        width: 150
      });
    if (component.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      tableConfig.push(
        {
          field: 'lei',
          width: 130
        }
      );
    }
    tableConfig.push(
      {
        field: 'country',
        width: 100,
        icon: (value: Customer) => value.country ? 'flag-icon flag-icon-' + value.country.toLowerCase() : '',
        mapId: value => ''
      },
      {
        field: 'language',
        width: 130,
        icon: (value: Customer) => value.language ? 'flag-icon flag-icon-' + value.language.toLowerCase() : '',
        mapId: value => ''
      });
    if (component.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      tableConfig.push(
        {
          field: 'town',
          width: 100
        },
        {
          field: 'desk',
          width: 100
        },
        {
          field: 'email',
          width: 100
        },
        {
          field: 'address',
          width: 150
        },
        {
          field: 'brokerageTableName',
          width: 100
        }
      );
    }
    return tableConfig;
  }

  enableRecord(component: CustomerComponent, record: Customer) {
    component.formRecord = record;
    if (component.formRecord) {
      component.formRecord.enabled = !component.formRecord.enabled;
      component.save();
    }
  }
}
